require("./gtm");

window.flashMessage = (key, level = '') => {
    let text = window.laravel.translations[key];
    let el = $(`
        <div class="flash-message ${level}">
            <span class="btn-close">&times;</span>
            <p class="message">${text}</p>
        </div>
    `);

    $("body").prepend(el);

    el.delay(5000).slideUp(300);
};

// Toggle full screen loading
window.loading = (show = true) => {
    $("body").toggleClass("loading", show);
};

// toggling menu - states open and close
function menuToggler() {
    let nav = document.getElementById("mainNav");
    let burger = document.getElementById("navBurger");
    let icon = document.getElementById("navUser");

    /*
     if navbar not opened (responsive), open it and change burger icon
     else remove the class and change the icon back
     */
    if (nav.getAttribute("data-opened") == "false") {
        nav.className = "container responsive";
        burger.className += " open";
        nav.setAttribute("data-opened", "true");

        //closing other menu
        icon.className = "user-icon";
        nav.setAttribute("data-user-opened", "false");
    } else {
        nav.className = "container";
        burger.className = "burger-icon";
        nav.setAttribute("data-opened", "false");
    }
}

// toggling user menu - states open and close
function userToggler() {
    let nav = document.getElementById("mainNav");
    let icon = document.getElementById("navUser");
    let burger = document.getElementById("navBurger");

    /*
     if navbar not opened (responsive), open it and change icon
     else remove the class and change the icon back
     */
    if (nav.getAttribute("data-user-opened") == "false") {
        nav.className = "container responsive-user";
        icon.className += " open";
        nav.setAttribute("data-user-opened", "true");

        //closing other menu
        burger.className = "burger-icon";
        nav.setAttribute("data-opened", "false");
    } else {
        nav.className = "container";
        icon.className = "user-icon";
        nav.setAttribute("data-user-opened", "false");
    }
}

function openSubnav(el) {
    if(el.className == "has-submenu")
        el.className = "has-submenu open";
    else
        el.className = "has-submenu";
}

function openTab(tabName){
    $(".measurement-tabs .tab").css("display", "none");
    $("#" + tabName).css("display", "block");
}

function closeModal(modal){
    modal.css("display", "none");
    $("body").css("overflow", "");
}

function openModal(modal){
    modal.css("display", "block");
    $("body").css("overflow", "hidden");
}

$(document).ready(function(){

    /*
    Flash messages
     */

    // Auto hide
    if ($('.flash-message').length) {
        $(".flash-message").delay(5000).slideUp(300);
    }

    // Close after users click
    $(document).on('click', '.flash-message .btn-close', function () {
        $(this).parent().hide();
    });

    /*
    Navbar events
     */
    $("#navBurger").on("click", menuToggler);
    $("#navUser").on("click", userToggler);
    $(".has-submenu").on("click", function() {
        openSubnav(this);
    });


    /*
    Carousels
     */
    $(".owl-carousel.reviews-carousel").owlCarousel({
        loop: true,
        nav: true,
        navText: ["<span aria-label='Previous'><img src='https://www.bespoken.cz/public/img/sipka_ruzova_btn_doleva.svg' alt='<'></span>",
            "<span aria-label='Previous'><img src='https://www.bespoken.cz/public/img/sipka_ruzova_btn_doprava.svg' alt='>'></span>"],
        dots: false,
        responsiveClass:true,
        responsive:{
            0:{
                items:1
            },
            767:{
                items:2
            },
            1201:{
                items:3
            }
        }
    });

    $(".owl-carousel.full-reviews-carousel").owlCarousel({
        loop: false,
        nav: true,
        navText: ["<span aria-label='Previous'><img src='https://www.bespoken.cz/public/img/sipka_ruzova_btn_doleva.svg' alt='<'></span>",
                "<span aria-label='Previous'><img src='https://www.bespoken.cz/public/img/sipka_ruzova_btn_doprava.svg' alt='>'></span>"],
        slideBy: 'page',
        dots: false,
        responsiveClass:true,
        mouseDrag: false,
        responsive:{
            0:{
                items:1
            },
            767:{
                items:3
            },
        },
        onInitialized: function(){
            let t = this,
                currSlide = Math.ceil(t._current / t.settings.items) + 1,
                length = Math.ceil(t._items.length / t.settings.items);
            $('<span class="slide-num">' + currSlide + '/' + length + '</span>').insertAfter('.owl-carousel.full-reviews-carousel .owl-nav .owl-prev');
        },
        onTranslate: function(){
            let t = this,
                currSlide = Math.ceil(t._current / t.settings.items) + 1,
                length = Math.ceil(t._items.length / t.settings.items);
            $(".owl-carousel.full-reviews-carousel .owl-nav .slide-num").html(currSlide + '/' + length);
        }
    });

    $(".owl-carousel.facts-carousel").owlCarousel({
        loop: false,
        nav: true,
        navText: ["<span aria-label='Previous'><img src='https://www.bespoken.cz/public/img/sipka_ruzova_btn_doleva.svg' alt='<'></span>",
            "<span aria-label='Previous'><img src='https://www.bespoken.cz/public/img/sipka_ruzova_btn_doprava.svg' alt='>'></span>"],
        dots: false,
        responsiveClass:true,
        responsive:{
            0:{
                items:2
            },
            767:{
                items:3
            },
            991:{
                items:6
            },
        }
    });

    $(".owl-carousel.production-carousel").owlCarousel({
        loop: true,
        nav: true,
        navText: ["<span aria-label='Previous'><img src='https://www.bespoken.cz/public/img/sipka_ruzova_btn_doleva.svg' alt='<'></span>",
            "<span aria-label='Previous'><img src='https://www.bespoken.cz/public/img/sipka_ruzova_btn_doprava.svg' alt='>'></span>"],
        dots: false,
        responsiveClass:true,
        responsive:{
            0:{
                items:1
            },
            576:{
                items:2
            },
            767:{
                items:3
            },
            991:{
                items:5
            },
        }
    });

    $(".owl-carousel.blog-carousel").owlCarousel({
        loop: true,
        nav: true,
        navText: ["<span aria-label='Previous'><img src='https://www.bespoken.cz/public/img/sipka_ruzova_btn_doleva.svg' alt='<'></span>",
            "<span aria-label='Previous'><img src='https://www.bespoken.cz/public/img/sipka_ruzova_btn_doprava.svg' alt='>'></span>"],
        dots: false,
        responsiveClass:true,
        responsive:{
            0:{
                items:1
            },
            576:{
                items:2
            },
            767:{
                items:3
            },
            991:{
                items:4
            },
        }
    });

    let measurementCarousel = $(".owl-carousel.measurement-carousel");
    measurementCarousel.owlCarousel({
        loop: true,
        nav: true,
        navText: ["<span aria-label='Previous'><img src='https://www.bespoken.cz/public/img/sipka_ruzova_btn_doleva.svg' alt='<'></span>",
            "<span aria-label='Previous'><img src='https://www.bespoken.cz/public/img/sipka_ruzova_btn_doprava.svg' alt='>'></span>"],
        dots: false,
        items: 1
    });
    measurementCarousel.on('changed.owl.carousel', function (e) {
        let currStep = $(this).find('.step:eq(' + (e.item.index) +')');
        if(currStep && currStep.attr('src-image'))
            $(this).closest('.half-jumbotron').find('.asset-container > img').attr('src', currStep.attr('src-image'));

    });

    /*
    FAQ accordion
     */
    let acc = document.getElementsByClassName("accordion");
    let i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
            /* Toggle between adding and removing the "active" class,
            to highlight the button that controls the panel */
            this.classList.toggle("active");

            /* Toggle between hiding and showing the active panel */
            let panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
    }

    /*
    Modals
     */
    $(".open-ig-modal").on("click", function (e) {
        e.preventDefault();
        let link = $(this).attr('href');
        let modal = $("#igModal");

        //proper link structure checked
        link = link.endsWith('/') ? link : link + "/";
        link = link.endsWith('embed/') ? link : link + "embed/";

        //iframe src adjusted
        $("#igModal iframe").attr("src", link);
        //modal visible
        openModal(modal);
    });

    $(".close-ig-modal").on("click", function () {
        let modal = $("#igModal");
        //iframe src adjusted
        $("#igModal iframe").attr("src", "about:blank");
        //modal visible
        closeModal(modal);
    });

    $(window).on("click", function (e) {
        let modal = $("#igModal");
        if(e.target.id == "igModal")
            closeModal(modal);
    })

    /*
    Tooltips
     */
    $('.tooltip').tooltipster({
        contentAsHTML: true,
        theme: 'custom-tooltip-theme',
        delay: 100
    });
    $('.tooltip-img').tooltipster({
        contentAsHTML: true,
        theme: 'custom-tooltip-theme-2',
        delay: 100
    });

    /*
    Tabs
     */
    $(".measurement-tabs .tabs-bar .tab-button").on("click", function () {
        $(".measurement-tabs .tabs-bar .tab-button").removeClass("active");
        $(this).addClass("active");
    })

    $(".measures-table .edit-btn").on("click", function () {
        let line = $(this).parents(".line");
        //$(".line.active").removeClass("active");
        line.find(".table-editing").css("visibility", "visible");
        line.find(".edit-btn").css("display", "none");
        line.find(".cancel-btn").css("display", "inline-block");
        line.addClass("active");
    });

    $(".measures-table .save-btn, .measures-table .cancel-btn").on("click", function () {
        let line = $(this).parents(".line");
        line.removeClass("active");
        line.find(".table-editing").css("visibility", "hidden");
        line.find(".edit-btn").css("display", "inline-block");
        line.find(".cancel-btn").css("display", "none");
    });

    /*
    About Us page - lightbox gallery
     */
    $('.featherlight-gallery a').featherlightGallery({
        previousIcon: "<img src='https://www.bespoken.cz/public/img/sipka_ruzova_btn_doleva.svg' alt='<' width='30'>",
        nextIcon: "<img src='https://www.bespoken.cz/public/img/sipka_ruzova_btn_doprava.svg' alt='<' width='30'>",
        galleryFadeIn: 300,
        openSpeed: 300
    });

});

/*
dynamic addresses management
 */

//account
var checkBox = document.getElementsByClassName("addresses__checkbox__checkbox")[0],
    cartCheckBox = document.getElementsByClassName("invoice__data__checkbox__checkbox")[0],
    invoiceAddress = document.getElementsByClassName("invoice__addresses")[0],
    registerCheckBox = document.getElementsByClassName("register__checkbox__checkbox")[0],
    registerForm = document.getElementsByClassName("register__addresses")[0];

function displayAddress(){
    if (checkBox.checked){
        $(invoiceAddress).css({
            "display": "none"
        });
    }
    else{
        $(invoiceAddress).css({
            "display": "block"
        })
    }
};

function displayInvoiceData(){
    if (!cartCheckBox.checked){
        $(invoiceAddress).css({
            "display": "none"
        });
    }
    else{
        $(invoiceAddress).css({
            "display": "block"
        })
    }
};

function displayRegisterForm(){
    if (!registerCheckBox.checked){
        $(registerForm).css({
            "display": "none"
        });
    }
    else{
        $(registerForm).css({
            "display": "block"
        })
    }
};

//buttons interaction
var manageBtns = {
    show : function(e){
        let btn = $(e.currentTarget);
        let parent = btn.parent();
        // There is Delete button next to Edit button
        let hasSibling = parent.hasClass("table--sibling__btns");

        if (hasSibling)
            parent = parent.parent();

        parent.find("input, select").attr("readonly", false);
        if (hasSibling)
            btn.parent().hide();
        else
            btn.hide();
        parent.find(".table--editable__btns").css({
            "display": "flex"
        });
    },
    hide : function(e){
        let btn = $(e.currentTarget);
        let parent = btn.parent();
        // There is Delete button next to Edit button
        let hasSibling = parent.parent().find(".table--sibling__btns").length > 0;

        parent.parent().find("table").find("input, select").attr("readonly", true).each(function(){
            $(this).val($(this).data("original-value"));
        });
        parent.hide();

        if (hasSibling)
            parent.parent().find(".table--sibling__btns").css({
                "display": "flex"
            });
        else
            parent.parent().find(".btn__edit").css({
                "display": "block"
            });
    }
};

$(document).ready(function(){
    $(".managebtns-show").on("click", manageBtns.show);
    $(".managebtns-hide").on("click", manageBtns.hide);
    $(".click-displayaddress").on("click", displayAddress);
    $(".click-displayinvoicedata").on("click", displayInvoiceData);
    $(".click-displayregisterform").on("click", displayRegisterForm);

    if (checkBox)
        displayAddress();

    if (cartCheckBox)
        displayInvoiceData();

    if (registerCheckBox)
        displayRegisterForm();

    $("#measurements-type-select").change(e => {
        let select = $(e.target);
        let type = select.val();

        select.closest(".tabs-content").find("table").attr("data-type", type);
        $("[data-fill-type]").val(type);
    });

    // Modals
    $("[data-open-modal]").on("click", function() {
        openModal($($(this).data("open-modal")));
    });

    $("[data-close-modal]").on("click", function() {
        closeModal($($(this).data("close-modal")));
    });
});

/*
addresses end
 */

require("./cart");
